<template>
  <div id="contenedor-licitaciones-toolbar">
    <v-toolbar flat>
      <div style="width: 150px" class="mr-2">
        <ejercicio-picker
          v-model="filtros.ejercicio"
          class="mr-2">
        </ejercicio-picker>
      </div>
      <div style="width: 350px" class="mr-2">
        <custom-text-field
          label="Buscar..."
          append-icon="mdi-magnify"
          clearable
          @keyup="buscar"
          @click:clear="limpiarBuscadorTexto"
        >
        </custom-text-field>
      </div>
      <filtros
        :licitaciones="listaLicitaciones"
        :filtros="filtros">
      </filtros>
      <v-spacer></v-spacer>
      <registrar-nueva-licitacion></registrar-nueva-licitacion>
    </v-toolbar>
  </div>
</template>

<script>
import Filtros from './Filtros.vue';
import RegistrarNuevaLicitacion from '@/components/administracion/licitaciones/Nueva.vue';
import EjercicioPicker from '@/components/inputs/EjercicioPicker.vue';
import CustomTextField from '@/components/inputs/sinColumnas/TextField.vue';

export default {
  name: 'ToolBarLicitaciones',
  props: {
    listaLicitaciones: {
      type: Array,
      required: true,
    },
    filtros: {
      type: Object,
      required: true,
    },
  },
  components: {
    Filtros,
    EjercicioPicker,
    CustomTextField,
    RegistrarNuevaLicitacion,
  },
  data() {
    return {
      debounce: null,
    };
  },
  methods: {
    buscar(e) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.filtros.buscarTexto = e.target.value;
      }, 600);
    },
    limpiarBuscadorTexto() {
      this.filtros.buscarTexto = '';
    },
    abrirCalendario() {
      this.$emit('abrirCalendario');
    },
    nuevo() {
      this.$emit('nuevaLicitacion');
    },
  },
};
</script>

<style lang="scss">
</style>
